import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { InputGroup, InputGroupText, Input, Button } from "reactstrap";
import axios from "axios";
import { baseUrl } from "..";
import {Box, Typography } from "@mui/material";
import Paper from '@mui/material/Paper';
import nightImage from "../Assets/nightImage.png";
import bedImage from "../Assets/bedImage.png";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Logo from "../Assets/Logo.svg";
import withRouter from "../Components/withRouter";
import { downloadCSV } from "../Utils/downloadCSV";
const column = [
          
    {field:'customerEmail',headerName:'Email',  width: "170",},
    {field:'phoneNumber',headerName:'Phone No.',width: "120",},
    {field:'PaymentCollectedFromCustomer',headerName:'Paid at Booking point',width: "100",},
    {field:'PaymentPendingFromCustomer',headerName:'To be Collected',width: "100",},
    { field: 'bookingDate', headerName: 'Booking Date', width: "110", },
    { field: 'booking_id', headerName: 'Booking Id', width: "100", },
    { field: 'roomType', headerName: 'Room Type', width: "150", },
    { field: 'customerName', headerName: 'Customer', width: "100", },
    { field: 'checkInDate', headerName: 'CheckIn Date', width: "100",},
    { field: 'checkOutDate', headerName: 'CheckOut Date', width: "100",},
    { field: 'totalRooms', headerName: 'No. of Rooms', width: "50", },
    { field: 'cost', headerName: 'Cost', width: "80", },
    // { field: 'id', headerName: 'Action', flex: 1 },
    { field: 'utrNumber', headerName: 'UTR Number', width: "100",},
    { field: 'transferredTime', headerName: 'Transferred Time',width:"160" },
    { field: 'comissionAmt', headerName: 'Commission Amt ', width: "100", },

            { field: "amountTobePaidByThc",headerName: "Amount to be paid by THC",editable: false,width: "160",},
            { field: "totalHostelRevenue",headerName: "Total Hostel Revenue",editable: false,width: "160"},
            { field: "status",headerName: "Booking status",editable: false,width: "160"},
]

class Reservation extends React.Component {
    constructor() {
        super()
        this.state = {
      utrNumbers:new Map(),
      loading:false,
            pageSize: 10,
            open: false,
            selectedBooking: null,
            currentPage: 0,
            searchInput: "",
            allTableData: [],
            filteredData: [],
            firstDate: "",
            secondDate: "",
            filterType:"",
            isLaptop: window.matchMedia("(min-width: 1024px)").matches,
            isMobile: window.matchMedia("(max-width: 768px)").matches,
            userRole: localStorage.getItem("userRole") || "",
            selectedHostelId: this.props?.userContext?.selectedHostelId || localStorage.getItem("selectedHostel") || "",
            statusFilter:""
        }
    }

    async componentDidMount() {
        // Only fetch if a hostel is selected
        // const {selectedHostelId} = this.props.userContext;
        console.log(this.props)
        const {selectedHostelId} = this.props?.userContext?.selectedHostelId;
        this.setState({
          selectedHostelId: selectedHostelId
        })
        if (this.props?.userContext?.selectedHostelId || this.state.selectedHostelId) {
         await   this.fetchUtrNumbers();
            this.fetchReservations();
        }
        this.mediaQuery = window.matchMedia("(min-width: 1024px)");
        this.mediaQuery.addEventListener("change", this.handleResize);
        this.mediaQueryList = window.matchMedia("(max-width: 768px)");
        this.mediaQueryList.addEventListener("change", this.updateScreenSize);
    }

    componentWillUnmount() {
        // Clean up media query listeners to prevent memory leaks
        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener("change", this.handleResize);
        }
        if (this.mediaQueryList) {
            this.mediaQueryList.removeEventListener("change", this.updateScreenSize);
        }
    }

async  componentDidUpdate(prevProps) {
         // Check if the selectedHostelId from userContext has changed
              const currentHostelId = this.props?.userContext?.selectedHostelId;
              const previousHostelId = prevProps?.userContext?.selectedHostelId;
              
              if (currentHostelId !== previousHostelId && currentHostelId) {
                
                  this.setState({ selectedHostelId: currentHostelId }, async() => {
                    console.log('feching reservation after update')
              await  this.fetchUtrNumbers()
                this.fetchReservations();
            });
        }
    }




       fetchUtrNumbers  =async() =>{
        this.setState({loading:true})
            const headers = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
    try{
    const response = await axios.get(`${baseUrl}/payments/get-payments-utr/${this.state.selectedHostelId}`,headers);
    if(response.status === 200){ 
       const utrMap = new Map();
          response.data.transactions.forEach((utrData) => {
            const rawTime = utrData.transferredDateTime || "";
            // Clean the string to remove newlines and trim whitespace
            const cleanedTime = rawTime.replace(/\s+/g, ' ').trim();
            utrMap.set(utrData.startDate, {utrNumber:utrData.utrNumber,transferredTime:cleanedTime});
          });
            this.setState({ utrNumbers: utrMap }, () => {
          });
    }
    }catch(err){
    console.log(err)
    }
    }
    


    getWeekStartDate(dateStr) {
  const date = new Date(dateStr)
  const day = date.getUTCDay()   
  const diff = date.getUTCDate() - day + (day === 0 ? -6 : 1)
  const weekStart = new Date(date.setUTCDate(diff))
  return weekStart.toISOString().split("T")[0] 
}



    fetchReservations = () => {
        const { userRole } = this.state;
        const selectedHostelId = this.props?.userContext?.selectedHostelId || this.state.selectedHostelId;
        
        // Don't fetch if no hostel is selected
        if (!selectedHostelId) {
            console.log('No hostel selected, skipping fetch');
            return;
        }
        
        const headers = {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        }
         axios.get(`${baseUrl}/reservations/${selectedHostelId}`, headers).then(response => {

   let mapData = response?.data.map((reservation) => {
  const bookingDate = reservation.bookingDate.split("T")[0];
  const date = this.getWeekStartDate(bookingDate);
  const utrData = this.state.utrNumbers?.get(date) || { utrNumber: "", transferredTime: "" };

  const feeCharged   = reservation?.platformFee || 0;
  const feeCollected = reservation?.platformFeeCollected || 0;

  const amountToBePaidByThc =
      (reservation?.PaymentCollectedFromCustomer || 0)
     - feeCharged
    + (reservation?.thcCouponAmt || 0)
    + (reservation?.thcCoinAmt || 0)
    + (reservation?.thcDiscount || 0)
    + (reservation?.thcAppDiscount || 0)
    - (reservation?.comissionAmt || 0);

  const rounded = Math.round((amountToBePaidByThc + Number.EPSILON) * 100) / 100;

  return {
    ...reservation,
    utrNumber: utrData.utrNumber || "",
    transferredTime: utrData.transferredTime || "",
    amountTobePaidByThc: rounded,
    totalHostelRevenue: rounded + (reservation?.PaymentPendingFromCustomer || 0),
    PaymentCollectedFromCustomer: (reservation?.PaymentCollectedFromCustomer || 0) - feeCollected,
  };
});

          const fields = column.map(col => col.field);
           const filteredData = mapData.map(item => {
  const cleanedItem = Object.fromEntries(
    Object.entries(item).filter(([key]) => fields.includes(key))
  );

  return {
    ...cleanedItem,
    status: item.status === "cancel" ? "cancel" : "confirm"
  };
});

const sortedFilteredData = filteredData.sort(
  (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate)
);

            this.setState({ allTableData: filteredData, filteredData: sortedFilteredData })
        }).catch(err => {
            console.log(err.message)
        })
        this.mediaQuery = window.matchMedia("(min-width: 1024px)");
        this.mediaQuery.addEventListener("change", this.handleResize);
        this.mediaQueryList = window.matchMedia("(max-width: 768px)");
        this.mediaQueryList.addEventListener("change", this.updateScreenSize);
    }
    
    handleResize = (event) => {
        this.setState({ isLaptop: event.matches });
      };
    
      updateScreenSize = (event) => {
          this.setState({ isMobile: event.matches });
        };

    handleFilter = () => {
        const { allTableData, firstDate, secondDate, searchInput, filterType ,statusFilter } = this.state;
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        const next7Days = new Date(today);
        next7Days.setDate(today.getDate() + 7);

        const filteredData = allTableData.filter(eachData => {
            const bookingDate = new Date(eachData.bookingDate);
            const checkInDate = new Date(eachData.checkInDate);
            const newfirstDate = firstDate ? new Date(firstDate) : null;
            const newsecondDate = secondDate ? new Date(secondDate) : null;
    
            const dateCondition =
                (!newfirstDate || bookingDate >= newfirstDate) &&
                (!newsecondDate || bookingDate <= newsecondDate);
    
            const searchCondition = searchInput
                ? eachData.booking_id.toLowerCase().includes(searchInput.toLowerCase()) ||
                  eachData.roomType.toLowerCase().includes(searchInput.toLowerCase()) ||
                  eachData.customerName.toLowerCase().includes(searchInput.toLowerCase())
                : true;
            
            let filterCondition = true;
            if (filterType === 'today') {
                filterCondition = checkInDate.toDateString() === today.toDateString();
            } else if (filterType === 'tomorrow') {
                filterCondition = checkInDate.toDateString() === tomorrow.toDateString();
            } else if (filterType === 'yesterday') {
                filterCondition = checkInDate.toDateString() === yesterday.toDateString();
            } else if (filterType === 'next7Days') {
                filterCondition = checkInDate > today && checkInDate <= next7Days;
            }



            let statusConditon = true;

          switch (statusFilter) {
            case "cancelled":
              statusConditon = eachData?.status === "cancel";
              break;

            case "not-cancelled":
              statusConditon = eachData?.status !== "cancel";
              break;

            case "all":
            default:
              statusConditon = true;
          }
    
            return dateCondition && searchCondition && filterCondition && statusConditon;
        });
        this.setState({ filteredData });
    };

    setFilterType = (type) => {
        this.setState({ filterType: type }, this.handleFilter);
    };


setStatusFilter = (type) => {
  this.setState({ statusFilter: type }, this.handleFilter);
};

    handleCardClick = (booking) => {
        this.setState({
          selectedBooking: booking,
          open: true,
        });
      };
      
      handleClose = () => {
        this.setState({
          open: false,
          selectedBooking: null,
        });
      };
      handleCsvDownload = () =>{
        const sampleData = this.state.filteredData;
        if(!sampleData) {
          return;
        }
        downloadCSV(sampleData, "reservations.csv");
      }
    
    render() {
        const onChange = (e) => {
            const { name, value } = e.target
            if (name === "pageSize") {
                this.setState({ currentPage: 0 })
            }
            this.setState({ [name]: value }, () => {
                    this.handleFilter()                
            })
        }

        const {filterType ,statusFilter} = this.state;
        return (
            <div className="" style={{marginTop:"28px", marginBottom:"48px", marginLeft:"48px", marginRight:"48px"}}>
{this.state.isLaptop && (
  <div style={{background:""}}>
<div className="d-flex gap-3 mb-3">
  <Button
    style={{
      backgroundColor: statusFilter === "all" ? "#495057" : "#e9ecef",
      color: statusFilter === "all" ? "#ffffff" : "#495057",
      border: "none",
      borderRadius: "6px",
      padding: "6px 16px"
    }}
    onClick={() => this.setStatusFilter("all")}
  >
 All
  </Button>

  <Button
    style={{
      backgroundColor: statusFilter === "cancelled" ? "#495057" : "#e9ecef",
      color: statusFilter === "cancelled" ? "#ffffff" : "#495057",
      border: "none",
      borderRadius: "6px",
      padding: "6px 16px"
    }}
   onClick={() => this.setStatusFilter("cancelled")}
  >
    Cancelled
  </Button>

  <Button
    style={{
      backgroundColor: statusFilter === "not-cancelled" ? "#495057" : "#e9ecef",
      color: statusFilter === "not-cancelled" ? "#ffffff" : "#495057",
      border: "none",
      borderRadius: "6px",
      padding: "6px 16px"
    }}
    onClick={() => this.setStatusFilter("not-cancelled")}
  >
    Not-Cancelled
  </Button>
</div>




                <div className="d-flex justify-content-between mb-3"   style={{background:""}}>
                <div className="d-flex gap-2">
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'today' ? '#FD590C' : '#ff7933'}} onClick={() => this.setFilterType('today')}>Today</Button>
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'tomorrow' ? '#FD590C' : '#ff7933'}} onClick={() => this.setFilterType('tomorrow')}>Tomorrow</Button>
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'yesterday' ? '#FD590C' : '#ff7933'}} onClick={() => this.setFilterType('yesterday')}>Yesterday</Button>
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'next7Days' ? '#FD590C' : '#ff7933'}} onClick={() => this.setFilterType('next7Days')}>Next 7 Days</Button>
                </div>
                    <InputGroup className="border rounded w-25">
                        <InputGroupText className="bg-transparent border-0">
                            <i class="bi bi-search"></i>
                        </InputGroupText>
                        <Input className="border-0" placeholder="Search..." onChange={onChange} value={this.state.searchInput} name="searchInput" />
                    </InputGroup>
                    <div>
                    <button onClick={this.handleCsvDownload}>Download CSV</button>
                    </div>
                    {/* <div className="d-flex gap-3 align-items-center">
                        <Label>Rows per page</Label>
                        <Select
                            value={this.state.pageSize}
                            onChange={onChange}
                            name="pageSize"
                            label="Rows per page"
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                        </Select>
                    </div> */}
                    {/* <Button className="bg-blue-o text-dark-o border-0" color="dark">
                        Download
                    </Button> */}
                    <div className="d-flex gap-3 align-items-center">
                    <Input
                            type="date"
                            name="firstDate"
                            value={this.state.firstDate}
                            onChange={onChange}
                            className="form-control"
                        />
                        <Input
                            type="date"
                            name="secondDate"
                            value={this.state.secondDate}
                            onChange={onChange}
                            className="form-control"
                        />
                    </div>
                </div>
                </div>
)}
{this.state.isMobile && (
    <>
    <div className="d-flex gap-3" style={{marginBottom:"20px", marginRight:"60px"}}>
                        <InputGroup className="border rounded w-25" style={{height:"33px"}}>
                        <InputGroupText className="bg-transparent border-0" style={{paddingLeft:"4px", width:"85px"}}>
                            <i class="bi bi-search"></i>
                        <Input className="border-0" placeholder="Search..." onChange={onChange} value={this.state.searchInput} name="searchInput" style={{ height: '25px' ,width:"55px", paddingTop:"0px", paddingBottom:"2px", paddingRight:"0px", paddingLeft:"2px", fontSize:"14px"}}/>
                        </InputGroupText>
                    </InputGroup>
                    <Input
                            type="date"
                            name="firstDate"
                            value={this.state.firstDate}
                            onChange={onChange}
                            className="form-control"
                            style={{ height: '30px',width:"140px" }}
                        />
                        <Input
                            type="date"
                            name="secondDate"
                            value={this.state.secondDate}
                            onChange={onChange}
                            className="form-control"
                            style={{ height: '30px', width:"140px" }}
                        />
                        </div>
                <div className="d-flex justify-content-between mb-3" style={{paddingLeft:"0px"}}>
                <div className="d-flex gap-2">
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'today' ? '#FD590C' : '#ff7933', width:"83px", height:"45px",fontSize:"13px"}} onClick={() => this.setFilterType('today')}>Today</Button>
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'tomorrow' ? '#FD590C' : '#ff7933', width:"83px", height:"45px",fontSize:"12px"}} onClick={() => this.setFilterType('tomorrow')}>Tomorrow</Button>
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'yesterday' ? '#FD590C' : '#ff7933', width:"83px", height:"45px",fontSize:"12px"}} onClick={() => this.setFilterType('yesterday')}>Yesterday</Button>
                    <Button style={{color: "rgba(255, 255, 255, 1)", backgroundColor: filterType === 'next7Days' ? '#FD590C' : '#ff7933', width:"83px", height:"45px",fontSize:"12px"}} onClick={() => this.setFilterType('next7Days')}>Next 7 Days</Button>
                </div>
                </div>
                <div className="d-flex flex-column align-items-center justify-content-center pb-2" >
            <button onClick={this.handleCsvDownload}>Download CSV</button>
            </div>
                </>
)}
                {this.state.isLaptop && (
                <DataGrid
                getRowId={(row) => `${row.booking_id}-${row.roomType}`}
                    rows={this.state.filteredData}
                    columns={column}
                    pageSize={this.state.pageSize}
                    rowsPerPageOptions={[1, 2, 4]}
                    pagination
                    autoHeight
                    onPageChange={(params) => this.setState({ currentPage: params.page })}
                    onPageSizeChange={(params) => this.setState({ pageSize: params.pageSize })}
                    sx={{
                        borderRadius: 0, // Removes rounded corners
                        "& .MuiDataGrid-columnHeaders": {
                          borderRadius: 0, // Removes rounded corners for header
                        },
                        "& .MuiDataGrid-footerContainer": {
                          borderRadius: 0,
                          display: "flex",
                          justifyContent: "space-between", // Proper spacing for footer
                          alignItems: "center",
                          padding: "8px 16px",
                          minHeight: "40px",
                        },
                        "& .MuiTablePagination-root": {
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          justifyContent: "space-between",
                        },
                        "& .MuiTablePagination-toolbar": {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        },
                        "& .MuiTablePagination-selectLabel": {
                          display: "flex",
                          alignItems: "center",
                          marginRight: "8px", // Adds spacing between "Rows per page" and the select
                          marginTop: "14px",
                        },
                        "& .MuiSelect-select": {
                          paddingRight: "32px !important", // Space for dropdown arrow
                          paddingLeft: "8px", // Adds spacing between number and arrow
                          height: "32px !important",
                          display: "flex",
                          alignItems: "center",
                          lineHeight: "normal",
                          textAlign: "center",
                        },
                        "& .MuiSelect-icon": {
                          right: "8px", // Positions the arrow properly
                          top: "50%", // Centers it vertically
                          transform: "translateY(-50%)",
                          marginLeft: "4px", // Space between number and arrow
                        },
                        "& .MuiTablePagination-displayedRows": {
                          marginTop: "14px", // Moves "1-2 of 2" slightly downward
                        },
                        "& .MuiTablePagination-actions": {
                          display: "flex",
                          alignItems: "center",
                        },



                                                 '& .MuiDataGrid-columnHeader': {
      padding: '10px 8px',
      alignItems: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      whiteSpace: 'normal',
      lineHeight: '1.3',
      textAlign: 'center',
      fontSize: '13px',
    },
                      }}

  columnHeaderHeight={90}
                        
                /> 
                )}
                {this.state.isMobile && (
                    <>
{[...this.state.filteredData] // clone the array to avoid mutating state
  .sort((a, b) => new Date(b.checkInDate) - new Date(a.checkInDate)) // descending order by check-in date
  .map(eachCard => {
                        return(
      <React.Fragment key={`${eachCard.booking_id}-${eachCard.roomType}`}> {/* Make sure each child has a key */}
        <Dialog
          fullScreen
          open={this.state.open && this.state.selectedBooking?.booking_id === eachCard.booking_id}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
    <img
      src={Logo} // or use a variable like {logo}
      alt="Logo"
      style={{ marginTop:16,width: 129, height: 32, marginRight: 16 }}
    />
      {/* Centered image below title */}
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 20, mb: 2 }}>
    <img
      src={Logo}
      alt="Centered Graphic"
      style={{ maxWidth: '80%', height: 'auto' }}
    />
  </Box>
  {this.state.selectedBooking && (
      <Typography variant="h4" sx={{ mt: 1, fontWeight: 'bold', textAlign: 'center' }}>
      {this.state.selectedBooking.customerName}
    </Typography>
  )}
            <Paper 
            elevation={5}
            sx={{
                borderRadius: 6,
                padding: 2,
                mt: 7,
                ml: 4,
                mr: 4,
                mb: 4,
              }}>
          <Typography sx={{ fontSize: '30px', textAlign: 'center' }}><strong>Booking Summary</strong></Typography>
          <hr style={{ borderTop: '2px solid #000000' }}></hr>
          <DialogContent>
            {this.state.selectedBooking && (
              <Box>
                <Typography>Customer Name:</Typography>
                <Typography><strong>{this.state.selectedBooking.customerName}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Email ID:</Typography>
                <Typography><strong>{this.state.selectedBooking.customerEmail}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Phone Number:</Typography>
                <Typography><strong>{this.state.selectedBooking.phoneNumber}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Booking Details</Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Check-in: <strong>{this.state.selectedBooking.checkInDate}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Check-out: <strong>{this.state.selectedBooking.checkOutDate}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Bed Type: <strong>{this.state.selectedBooking.roomType}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>No. of Beds: <strong>{this.state.selectedBooking.totalRooms}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>
                  Payment Status:{" "}
                  <span style={{ color: this.state.selectedBooking.paymentStatus === 'Pending' ? 'orange' : 'green' }}>
                    {this.state.selectedBooking.paymentStatus}
                  </span>
                </Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Paid At Booking: Rs. <strong>{this.state.selectedBooking.PaymentCollectedFromCustomer}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Payment Due @ Check-In: Rs. <strong>{this.state.selectedBooking.PaymentPendingFromCustomer}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Coupon: <strong>{this.state.selectedBooking?.couponCode===""? "Not Used" : "Used"}</strong></Typography>
                <Typography sx={{ mt: 2, fontSize: '15px' }}>Transaction ID: <strong>{this.state.selectedBooking.booking_id}</strong></Typography>
              </Box>
            )}
          </DialogContent>
          </Paper>
          <DialogActions>
            <Button onClick={this.handleClose}>Close</Button>
          </DialogActions>
        </Dialog>

                            <Box sx={{ width: '100%' }} style={{marginLeft:"0px"}}>
    <Paper
      elevation={1}
      onClick={() => this.handleCardClick(eachCard)}
      sx={{
        borderRadius: 2,
        padding: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 2,
        backgroundColor: "rgba(229, 229, 229, 0.3)",
      }}
    >
      {/* LEFT SIDE */}
      <Box>
        <Typography variant="h5" color="rgba(0, 0, 0, 1)" sx={{ mb: 2 }}>{eachCard.customerName}</Typography>
        <Typography variant="body2" color="rgba(107, 114, 120, 1)">
          Date: {eachCard.checkInDate}
        </Typography>
        <Typography variant="body2" color="rgba(107, 114, 120, 1)" sx={{ fontSize: "0.80rem" }}>
          To be collected: {eachCard.PaymentPendingFromCustomer}
        </Typography>
      </Box>

      {/* RIGHT SIDE */}
      <Box sx={{ minWidth: 160 }}>
      <Box display="flex" justifyContent="flex-end" gap={0} sx={{mt:4}}>
        <Typography variant="body2" color="rgba(50, 51, 51, 1)"  sx={{ minWidth: 100, fontWeight: 500 }}>
          Type of Beds
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500 }} color="rgba(50, 51, 51, 1)">
            {eachCard.roomType}
        </Typography>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1} mt={1}>
          {/* <BedIcon fontSize="small" /> */}
          <img src={bedImage} alt="bed" style={{ width: 14, height: 14 }} />
          <Typography variant="body2" color="rgba(50, 51, 51, 1)" sx={{ fontWeight: 500 }}>
  {eachCard.totalRooms} bed{eachCard.totalRooms === 1 ? '' : 's'}
</Typography>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
          {/* <NightsStayIcon fontSize="small" /> */}
          <img src={nightImage} alt="bed" style={{ width: 14, height: 14 }} />
          <Typography variant="body2" color="rgba(50, 51, 51, 1)" sx={{ fontWeight: 500 }}>
  {(() => {
    const checkIn = new Date(eachCard.checkInDate);
    const checkOut = new Date(eachCard.checkOutDate);
    const nights = Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24));
    return `${nights} night${nights === 1 ? '' : 's'}`;
  })()}
</Typography>
        </Box>
      </Box>
    </Paper>
    </Box>
    </React.Fragment>
                        )
                    })}
</>
                )}
            </div>
        )
    }
}

export default withRouter(Reservation)
